<template>
  <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm" novalidate>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-slider"></i>
                <h2 class="card-big-info-title">Područje primjene</h2>
              </div>

              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.title.$invalid && $v.$dirty }">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv prostora</label>
                  <div class="col-lg-7 col-xl-6">
                    <input type="text" class="form-control form-control-modern" placeholder="Naziv prostora" v-model="title"/>

                    <form-error :model="$v.title" :dirty="$v.$dirty" label="Naziv prostora" />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.description.$invalid && $v.$dirty }">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis prostora</label>
                  <div class="col-lg-7 col-xl-6">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="description"
                      placeholder="Opis prostora"
                    ></textarea>

                    <form-error :model="$v.description" :dirty="$v.$dirty" label="Opis prostora" />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Nadredjeni prostor</label>
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="parentCleaningAreaId"
                      :multiple="false"
                      :options="cleaningAreas"
                      :show-count="true"
                      placeholder="Izaberite prostoriju"
                      v-if="cleaningAreas"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Ikona</label>
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="file"
                      class="form-control form-control-modern"
                      ref="icon"
                      @change="handlePhotoUpload"
                      accept="image/*"
                      :disabled="!parentCleaningAreaId"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row action-buttons">
      <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
        <router-link exact :to="{ name: 'CleaningAreas' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
          {{ translations.cancel }}
        </router-link>
        <button
          type="submit"
          class="
            submit-button
            btn btn-primary btn-px-4
            py-3 d-flex align-items-center
            font-weight-semibold line-height-1
          "
        >
          <i class="bx bx-save text-4 me-2"></i>{{ translations.save }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import api from '@/services/api';
import validations from './validation-schema/add';
import FormError from '@/components/shared/form-errors/FormError.vue';

export default {
  components: { FormError, Treeselect },
  name: 'AddCleaningArea',
  mixins: [translations],
  validations,
  computed: {
    cleaningAreas() {
      return this.$store.getters.getCleaningAreas.map(({ title, id }) => ({
        label: title,
        id,
      }));
    },
  },
  data() {
    return {
      title: '',
      description: '',
      parentCleaningAreaId: null,
      icon: '',
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      const { title, description, parentCleaningAreaId, icon } = this;

      const payload = {
        title,
        parentCleaningAreaId,
        description,
        icon
      };

      if (!this.$v.$invalid) {
        api.createCleaningArea(payload).then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CleaningAreas' });
        }).catch((err) => {
          this.$toast.error(err.response.data.info);
        });
      } else {
        this.$toast.error(this.translations.forms.notValid);
      }
    },
    handlePhotoUpload() {
      const file = this.$refs.icon.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      reader.onload = (e) => {
        this.icon = e.target.result.split(',')[1];
      };
    },
  },
  mounted() {
    this.$store.dispatch('getCleaningAreas', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
      retrieveOnlyParents: true
    });
  },
}
</script>